import { CardBody, Typography } from "@material-tailwind/react";
import React from "react";
import EmptyState from "../common/EmptyState";
import ClickBaseButton from "../common/buttons/ClickBaseButton";
import AddRole from "../../pages/settings/administrator/AddRole";

function NoAdmins({ handleOpen: getAdmins }: { handleOpen: () => void }) {
  const [openDialog, setOpenDialog] = React.useState(false);
  return (
    <CardBody placeholder={undefined}>
      <div className="justify-center flex h-20">
        <EmptyState />
      </div>
      <Typography placeholder={undefined}>No Admins yet, add one</Typography>
      <ClickBaseButton onClick={() => setOpenDialog(!openDialog)}>
        Add a role
      </ClickBaseButton>
      <AddRole
        open={openDialog}
        getAdmins={getAdmins}
        handleOpen={() => setOpenDialog(!openDialog)}
      />
    </CardBody>
  );
}

export default NoAdmins;
